import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { 
  BottomNavigation as MuiBottomNavigation, 
  BottomNavigationAction,
  Paper 
} from '@mui/material';
import {
  Home,
  BarChart,
  Person,
} from '@mui/icons-material';

const BottomNavigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const getActiveTab = () => {
    if (location.pathname === '/') return 0;
    if (location.pathname === '/stats') return 1;
    if (location.pathname === '/profile') return 2;
    return 0;
  };
  
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate('/');
        break;
      case 1:
        navigate('/stats');
        break;
      case 2:
        navigate('/profile');
        break;
    }
  };

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0,
        zIndex: 1000,
        borderRadius: 0, // Remove rounded corners
      }} 
      elevation={8}
    >
      <MuiBottomNavigation
        value={getActiveTab()}
        onChange={handleChange}
        showLabels
        sx={{
          height: 80,
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            padding: '12px 12px 16px',
            minHeight: 80,
          },
        }}
      >
        <BottomNavigationAction 
          label="Home" 
          icon={<Home />} 
        />
        <BottomNavigationAction 
          label="Stats" 
          icon={<BarChart />} 
        />
        <BottomNavigationAction 
          label="Profile" 
          icon={<Person />} 
        />
      </MuiBottomNavigation>
    </Paper>
  );
};

export default BottomNavigation; 